import { useMutation } from "@tanstack/react-query";
import CurrencyService from "../services";
import { Currency } from "../settingsType/Currency";

const useUpdateCurrency = () => {
  return useMutation({
    mutationFn: ({
      documentId,
      updatedCurrency,
    }: {
      documentId: string;
      updatedCurrency: Currency;
    }) => CurrencyService.update(documentId, updatedCurrency), // Assuming update API takes an ID and the updated data
    onSuccess: () => {
    },
    onError: (error) => {
      console.error("Error updating currency:", error);
    },
  });
};

export default useUpdateCurrency;
